<style scoped>
  .TVChartContainer {
    height: 560px;
    margin-top: -10px;
    background-color: var(--color-chart);
    /*width: 1200px;*/
  }
  .dragger {
    height: 6px;
    background-color: var(--color-background);
    cursor: ns-resize;
  }
  .resizing1 {
    pointer-events: none;
  }
</style>
<template>
  <div>
    <div class="TVChartContainer" :class="{ resizing1 : resizing }" :id="containerId"></div>
    <div class="dragger" @mousedown="initResize" style="margin-top: -5px; padding-bottom: 10px"><img src="@/assets/dragger2.png"/></div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator'
import { sha256 } from 'js-sha256'
import { Fastbot, FastbotData, Smartlimit } from '@/util/types'
// @ts-ignore
import { widget as Widget } from '@/lib/charting_library'
// @ts-ignore
import FBotdatafeed from '@/services/fbotdatafeed/'
import fastbot from '@/services/fastbot'
// @ts-ignore
import Api from '@/util/api'
import MobileDetect from 'mobile-detect'
// @ts-ignore
import Util from '@/util/util'

@Component({
  components: {
  }
})
export default class FastbotTV extends Vue {
  element: any = null
  resizing = false
  containerId = 'fastbot_tv_chart_container'
  tvWidget: any = null
  lastOrderLine: any = null
  prevState: string = ''

  get fbotdata () {
    // @ts-ignore
    return (this.$store.state.fastbot as FastbotData)
  }

  get chartSymbol () {
    return 'FUTURES:' + this.fbotdata.asset + '/USDT'
  }

  async mounted () {
    // console.log('FastbotTV mounted')
    await fastbot.updateFastbotExchangeAsync()
    // console.log('fastbot.updateFastbotExchangeAsync()')
    // @ts-ignore
    Api.get('user/tvdata?mode=booster&cmd=load&token=' + this.$store.state.sys.token, { transformResponse: (res: any) => res })
      .then((res: any) => {
        this.createFastbotChart(res.data)
        // console.log('booster tvdata loaded')
      })
      .catch((error: any) => {
        console.log(error)
      })
  }

  beforeDestroy () {
    if (this.tvWidget) {
      const oldWidget = this.tvWidget
      this.tvWidget = null
      oldWidget.remove()
    }
  }

  @Watch('fbotdata.asset')
  changeSymbol () {
    // console.log('symbol change:', this.fbotdata.asset)
    if (this.tvWidget && this.tvWidget._ready && this.tvWidget.chart()) {
      this.tvWidget.chart().setSymbol(this.chartSymbol, () => {
        // console.log('symbol change loaded')
        // this.saveNeeded()
      })
    }
  }

  @Watch('fbotdata.excOrders')
  updateTVShapes () {
    if (this.fbotdata.excOrders === null || !this.tvWidget) {
      return
    }
    this.drawExecutedOrdersArrowsAndLastOrderLine()
  }

  @Watch('$store.state.fastbot.showArrows')
  showFilledArrows (value:Boolean) {
    if (value) {
      const orders = this.fbotdata.excOrders

      if (orders && orders.length) {
        this.cleanFilledArrows()
        if (this.fbotdata.excOrders.length) {
          this.fbotdata.excOrders.forEach(order => {
            this.addOrderArrowShape(order)
          })
        }
      }
    } else {
      this.cleanFilledArrows()
    }
  }

  stopResize (e: any) {
    window.removeEventListener('mousemove', this.resize, true)
    window.removeEventListener('mouseup', this.stopResize, false)
    this.resizing = false
  }

  resize (e: any) {
    this.element.style.height = (e.clientY - this.element.offsetTop - 10) + 'px'
  }

  initResize () {
    this.resizing = true
    this.element = document.getElementById(this.containerId)
    window.addEventListener('mousemove', this.resize, true)
    window.addEventListener('mouseup', this.stopResize, false)
  }

  drawExecutedOrdersArrowsAndLastOrderLine () {
    this.cleanFilledArrows()
    if (this.lastOrderLine != null) {
      this.lastOrderLine.remove()
      this.lastOrderLine = null
      // console.log('lastOrderLine remove')
    }
    if (this.$store.state.fastbot.showArrows && this.fbotdata.excOrders.length) {
      this.fbotdata.excOrders.forEach(slim => {
        this.addOrderArrowShape(slim)
      })
      this.addLastOrderLine(this.fbotdata.excOrders[this.fbotdata.excOrders.length - 1])
      // console.log('addLastOrderLine')
    }
  }

  addLastOrderLine (order: Smartlimit) {
    if (!this.fbotdata.selected || !this.tvWidget || !this.tvWidget._ready || !this.tvWidget.chart()) {
      return
    }
    const color = '#f5f5f5'
    this.lastOrderLine = this.tvWidget.chart().createOrderLine()
      .setText('')
      .setPrice(parseFloat(order.Price))
      .setQuantity('')
      .setLineStyle(2)
      .setLineWidth(2)
      .setLineLength(100)
      .setLineColor(color)
      .setBodyBorderColor(color)
      .setBodyBackgroundColor('#ffffff')
      .setBodyTextColor(color)
      .setQuantityBorderColor(color)
      .setQuantityBackgroundColor(color)
      .setCancelButtonBorderColor(color)
      .setCancelButtonIconColor(color)
  }

  cleanFilledArrows () {
    if (!this.tvWidget) {
      return
    }
    if (this.tvWidget && this.tvWidget._ready && this.tvWidget.chart() && this.fbotdata.excOrdersArrows.length > 0) {
      this.fbotdata.excOrdersArrows.forEach(a => {
        this.tvWidget.chart().removeEntity(a)
        // console.log('arrowShape removed', a)
      })
      this.fbotdata.excOrdersArrows = []
    }
  }

  addOrderArrowShape (order: Smartlimit) {
    if (!order.Executed || !this.tvWidget || !this.tvWidget._ready || !this.tvWidget.chart()) {
      return
    }
    // console.log('add order arrow', order.Executed)
    const shape = order.Side === 'B' ? 'arrow_up' : 'arrow_down'
    const time1 = new Date(order.Executed)
    // console.log('time1', time1, time1.getTime() / 1000)
    const arrow = this.tvWidget.chart().createShape(
      {
        time: time1.getTime() / 1000,
        price: parseFloat(order.Price)
      }, {
        shape,
        lock: true,
        zOrder: 'top',
        disableSelection: true,
        disableSave: true,
        disableUndo: true,
        showInObjectsTree: false
      })
    this.fbotdata.excOrdersArrows.push(arrow)
    // console.log('arrowShape added', arrow)
  }

  saveBoosterTV (state: any) {
    const statestr = JSON.stringify(state)
    if (statestr === this.prevState) {
      // console.log('tvdata save skipped')
      return
    }
    const md = new MobileDetect(window.navigator.userAgent)
    if (md.mobile()) {
      return
    }
    // @ts-ignore
    Api.post('user/tvdata?mode=booster&cmd=save&token=' + this.$store.state.sys.token, state)
      .then((res: any) => {
        // console.log(res)
        this.prevState = statestr
        // console.log('booster tvdata saved', state)
      })
      .catch((error: any) => {
        console.log(error)
      })
  }

  saveBoosterTVNeeded () {
    // console.log('BOT onAutoSaveNeeded')
    this.tvWidget.save(this.saveBoosterTV)
  }

  createFastbotChart (tvdatastr: string) {
    const capicoAppBoosterTvInterval = 'capico_app_booster_tv_interval'
    // @ts-ignore
    const userId = sha256(this.$store.state.sys.email)
    // console.log('userId', this.$store.state.sys.email)
    let interval = localStorage.getItem(capicoAppBoosterTvInterval)
    if (!interval) {
      interval = '1'
    }
    // var md = new MobileDetect(window.navigator.userAgent)
    const disabledFeatures = ['header_symbol_search', 'timeframes_toolbar', 'header_compare']
    // if (md.mobile()) {
    //   disabledFeatures.push('left_toolbar')
    // }

    const widgetOptions: any = {
      debug: false,
      symbol: this.chartSymbol,
      datafeed: FBotdatafeed, // our datafeed object
      interval,
      container: this.containerId,
      library_path: '/app/charting_library/',
      custom_css_url: '/app/chart.css',
      // @ts-ignore
      locale: this.$store.state.sys.lang,
      timezone: Util.getTimezone(),
      disabled_features: disabledFeatures,
      enabled_features: ['side_toolbar_in_fullscreen_mode'],
      charts_storage_url: process.env.VUE_APP_TV_URL,
      charts_storage_api_version: '1.1',
      client_id: 'capico.app',
      user_id: userId,
      fullscreen: false,
      // allow_symbol_change: false,
      autosize: true,
      studies_overrides: {},
      auto_save_delay: 15,
      favorites: {
        intervals: ['1', '5', '15', '60', '1D'],
        chartTypes: ['Area', 'Candles']
      },
      theme: this.$store.getters.isThemeLight ? 'Light' : 'Dark',
      loading_screen: {
        foregroundColor: Util.getCssVariable('--color-accent'),
        backgroundColor: Util.getCssVariable('--color-chart')
      },
      overrides: {
        // "paneProperties.background": "#404364",
        // "paneProperties.vertGridProperties.color": "#363c4e",
        // "paneProperties.horzGridProperties.color": "#363c4e",
        'symbolWatermarkProperties.transparency': 90,
        // "scalesProperties.textColor": "#AAA",
        // "mainSeriesProperties.candleStyle.wickUpColor": "#336854",
        // "mainSeriesProperties.candleStyle.wickDownColor": "#7f323f",
        'mainSeriesProperties.showCountdown': true,
        // 'mainSeriesProperties.candleStyle.upColor': '#20b2aa',
        // 'mainSeriesProperties.candleStyle.downColor': '#f08080',
        'mainSeriesProperties.candleStyle.drawBorder': false,
        'paneProperties.vertGridProperties.style': 2,
        'paneProperties.horzGridProperties.style': 2

        // #404364
      }
    }

    if (tvdatastr) {
      // console.log('tvdata applied')
      widgetOptions.saved_data = JSON.parse(tvdatastr)
      // @ts-ignore
      const symbol1 = this.$store.state.bots.symbol.replace('_', '/')
      // console.log('this.chartSymbol', this.chartSymbol, symbol1)
      if (widgetOptions.saved_data && widgetOptions.saved_data.charts[0].panes[0].sources[0].state.symbol) {
        widgetOptions.saved_data.charts[0].panes[0].sources[0].state.symbol = this.chartSymbol
        widgetOptions.saved_data.charts[0].panes[0].sources[0].state.shortName = symbol1
      }
    }

    const tvWidget = new Widget(widgetOptions)

    this.tvWidget = tvWidget

    tvWidget.onChartReady(() => {
      tvWidget.subscribe('onAutoSaveNeeded', this.saveBoosterTVNeeded)
      Util.applyChartOverrides(tvWidget, 'booster')

      const subscr = tvWidget.chart().onDataLoaded()
      subscr.subscribe(null, () => {
        // console.log('onDataLoaded')
        this.drawExecutedOrdersArrowsAndLastOrderLine()
      })

      const subscr2 = tvWidget.chart().onIntervalChanged()
      subscr2.subscribe(null, (interval: any, obj: any) => {
        // console.log('onIntervalChanged', interval, obj)
        localStorage.setItem(capicoAppBoosterTvInterval, interval)
      })

      this.addButtons()
    })
  }

  addButtons () {
    const arrowsBtn = this.tvWidget.createButton()
    arrowsBtn.style.color = '#8e65e6'

    if (this.$store.state.fastbot.showArrows === true) {
      // @ts-ignore
      arrowsBtn.textContent = this.$text.tr('Bыкл') + ' ⇧'
    } else {
      // @ts-ignore
      arrowsBtn.textContent = this.$text.tr('Bкл') + ' ⇧'
    }

    arrowsBtn.addEventListener('click', () => {
      this.$store.state.fastbot.showArrows = !this.$store.state.fastbot.showArrows
      localStorage.setItem('fastbot_tv_showArrows', this.$store.state.fastbot.showArrows)
      if (this.$store.state.fastbot.showArrows === true) {
        // @ts-ignore
        arrowsBtn.textContent = this.$text.tr('Bыкл') + ' ⇧'
      } else {
        // @ts-ignore
        arrowsBtn.textContent = this.$text.tr('Bкл') + ' ⇧'
      }
    })
  }
}
</script>
